import React from 'react'

import { StyledFemiScope as S } from './FemiScope.styles'

type TProps = {
  children: React.ReactNode
}

export const FemiScope: React.FC<TProps> = ({ children }) => (
  <S.Wrapper>{children}</S.Wrapper>
)
